<mat-panel-title>
    <table>
        <tr>
            <td>
                <mat-icon class="material-symbols-outlined">{{matIconName}}</mat-icon>
            </td>
            <td>
                &nbsp;
            </td>
            <td>
                <h2>{{dialogData.Title}}</h2>
            </td>
        </tr>
    </table>
</mat-panel-title>
<br />
<mat-divider></mat-divider>
<br />
<div>
    {{dialogData.Message}}
</div>
<br />
<mat-divider></mat-divider>
<br />
<table>
    <tr>
        <td>
            <button mat-button (click)="confirm()">{{dialogData.AcceptButtonText}}</button>
        </td>
        <td>
            &nbsp;
        </td>
        <td>
            <button mat-button (click)="cancel()">{{dialogData.CancelButtonText}}</button>
    </tr>
</table>
